import { ErrorMessage } from "../../utils/Messages";
import BaseDomainService from "./baseDomainServices";

import { getValidationRuleList } from "../../utils/validation/generateValidationRule";
import { setAuthProps } from "../../utils/AuthenticationLibrary";
import { saveData } from "../../utils/LocalStorage/LocalStorageManager";


const userDetail = {
    userName: '',
    password: ''
}

export default class AuthenticationServices extends BaseDomainService {

    // API Get
    login = this.apiService.authServices.adminLogin;


    // Define the state variables
    dataItem;

    // define the form fields
    formFields = [
        {
            inputType: "text",
            tittle: "User Name/Email",
            placeholder: "Enter Username",
            fieldName: "userName",
            validation: [{ type: "require" }]
        },
        {
            inputType: "password",
            tittle: "Password",
            placeholder: "Enter Password",
            fieldName: "password",
            validation: [{ type: "require" }, { type: "password", message: "PasswordNotValid" }]
        }
    ]

    // Validation 
    validationRules = {}
    constructor() {
        super();
        this.onPaginationUpdate = this.onLogin.bind(this);
        this.dataItem = { ...userDetail };
    }

    //** API Calls 
    onLogin = (requst) => {
        this.apiService.onAPICall("login", this.login, requst, this.onAPIResponse, this.onUpdateState);
    }


    //** Service Event */
    onInitService() {
        //This method only call when we use form component and we can add all items which we on on form load 
        let valRule = getValidationRuleList(this.formFields)
        this.validationRules = valRule;
        this.onUpdateState({
            "validationRules": valRule,
            "resetValidationRule": this.resetValidationRule
        })
    }
    onResetData = () => {
        this.dataItem = { ...this.userDetail }
        this.onUpdateState({ addUserDetails: this.dataItem });
    }

    loginOnEnter = (e) => {
        if (e.charCode === 13) {
            this.login();
        }
    }

    onRedirectoDashboard = () => {
        this.onRedirect("/Dashboard");
    }

    //** Methods     */
    //  When we get response from  API
    onAPIResponse = (key, isSuccess, responseData, getRequest) => {
        if (!isSuccess) {
            if (responseData.statusCode === 401) {
                this.apiService.serviceManager.swalServices.Toaster(ErrorMessage.InvalidAuthorization);
                this.onUpdateState({ setIsLoad: false });
            } else {
                this.onUpdateState({ setIsLoad: false });
                return;
            }
        }
        switch (key) {
            case "login":
                if (responseData.isAuthenticated === true && responseData) {

                    let request = {
                        // ...responseData,
                        adminUserId: responseData.userId,
                        isAuthenticated: responseData.isAuthenticated,
                        sessionTimeout: responseData.sessionTimeout,
                        userDisplayName: responseData.userDisplayName,
                        userName: responseData.userName,
                        token: responseData.token,
                        roles: responseData.roles
                    }
                    setAuthProps(request);
                    const securityPermissions = responseData.securityPermissions;
                    saveData('SecurityPermission', securityPermissions);
                    this.onRedirectoDashboard();

                } else if (responseData.isAuthenticated === false) {
                    this.apiService.serviceManager.swalServices.Error(responseData.message);
                }
                else {
                    this.apiService.serviceManager.swalServices.Toaster(ErrorMessage.InvalidAuthorization);
                }
                this.onUpdateState({ setIsLoad: false });

                break;
            default:
                break;
        }
    }

}